import React from "react";
import { injectIntl } from "react-intl";
import { required } from "./validationCommons";
import { Field } from "redux-form";
import { RequiredSpan } from "./StyledComponents";
import { FieldWithValidation } from "./FormField";
import SelectFieldWithValidation from "./FormField";
import { FormattedMessage } from "react-intl";
import get from "get-value";
import ImgTooltip from "./ImgTooltip";
import { RenderSelectInput } from "./FormField";
const InputSelectFieldWithValidation = (props) => {
    const {
        style,
        label,
        field,
        options,
        isDisabled,
        isRequired,
        intlMessages,
        intl,
        handleChange,
        noEmpty,
        sort,
        customOptionsMsg,
        boldTooltip,
        isSearchable,
        useSelectInput,
        fieldValidations = [],
    } = props;
    let validations = [...fieldValidations];
    if (isRequired) {
        validations.push(required);
    }
    // Transform options for react-select format when using RenderSelectInput
    const transformedOptions =
        useSelectInput && options
            ? options.map((option) => {
                  // If option is already in {value, label} format, use it as is
                  if (typeof option === 'object' && option.value && option.label) {
                      return option;
                  }
                  // Otherwise, transform string options to {value, label} format
                  return {
                      value: option,
                      label: intlMessages
                          ? intl.formatMessage(intlMessages[option])
                          : option,
                  };
              })
            : options;

    const handleFormat = (value) => {
        // When using select input, extract label from object-based options
        if (useSelectInput) {
            // If value is already an object with label, return the label
            if (typeof value === 'object' && value !== null && value.label) {
                return value.label;
            }
            // If value is a string, find matching option and return its label
            if (typeof value === 'string' && transformedOptions) {
                const matchingOption = transformedOptions.find(option => option.value === value);
                if (matchingOption) {
                    return matchingOption.label;
                }
            }
            return value;
        }
        
        let format;
        if (customOptionsMsg) {
            format = get(
                customOptionsMsg.map((option) => ({
                    id: option.uuid,
                    translation: option.presetName,
                }))
            );
            return get(
                format.find((option) => option.id === value),
                "translation",
                value
            );
        } else if (intlMessages) {
            return intlMessages[value]
                ? intl.formatMessage(intlMessages[value])
                : value;
        } else {
            return value;
        }
    };

    const normalizeValue = (value) => {
        if (!useSelectInput || !value) return value;
        
        // If value is already an object with value/label, return as is
        if (typeof value === 'object' && value.value && value.label) {
            return value;
        }
        
        // If value is a string, find the matching option and return the full object
        if (typeof value === 'string' && transformedOptions) {
            const matchingOption = transformedOptions.find(option => option.value === value);
            return matchingOption || { value, label: value };
        }
        
        return value;
    };

    return (
        <div>
            {!!label && label instanceof Object && (
                <div className="row m-0">
                    <label className="col-form-label pl-0 font-weight-bold">
                        <FormattedMessage {...label} />
                        {!isDisabled && isRequired ? (
                            <RequiredSpan>{"\u00A0*"}</RequiredSpan>
                        ) : null}
                    </label>
                    {!!boldTooltip && (
                        <div className="p-1">
                            <ImgTooltip />
                        </div>
                    )}
                </div>
            )}
            <Field
                name={field}
                component={
                    isDisabled
                        ? FieldWithValidation
                        : useSelectInput
                        ? RenderSelectInput
                        : SelectFieldWithValidation
                }
                type="text"
                validate={validations}
                isDisabled={isDisabled}
                style={style}
                intlMessages={intlMessages}
                options={transformedOptions}
                format={
                    isDisabled
                        ? (value) => (value ? handleFormat(value) : undefined)
                        : useSelectInput
                        ? normalizeValue
                        : undefined
                }
                onChange={handleChange ? handleChange : undefined}
                isRequired
                label={label}
                isSmall
                placeholder="---"
                noEmpty={noEmpty}
                sort={sort}
                customOptionsMsg={customOptionsMsg}
                isSearchable={isSearchable}
            />
        </div>
    );
};
export default injectIntl(InputSelectFieldWithValidation);

